<div class="waitlistModal">
    <span class="closeBtn" (click)="close()">
        <mat-icon fontSet="material-icons-round">close</mat-icon>
    </span>
    <div class="title">
        <h1>{{ 'waitlistDialog.title' | translate }}</h1>
    </div>
    <p>{{ 'waitlistDialog.message' | translate }}</p>
    <input type="email" (input)="validate()" class="input" email [placeholder]="'waitlistDialog.insertEmail' | translate" [(ngModel)]="email" [disabled]="isLogged">

    <div class="actions">
        <button (click)="close()" mat-flat-button class="btn outlined">{{ 'orderHistory.needHelpDialog.cancel' | translate }}</button>
        <button [disabled]="!email || !validated" (click)="assign()" mat-flat-button class="btn default">{{ 'waitlistDialog.confirm' | translate }}</button>
    </div>
</div>